import React, { useState, useEffect, useRef } from "react";
import {
  View,
  ActivityIndicator,
  Pressable,
  TouchableWithoutFeedback,
} from "react-native";
import Svg, { Rect } from "react-native-svg";
import { WebView } from "react-native-webview";
import { getToken } from "@services/api";
import metrics from "@constants/metrics";
import handleCMSNavigation from "@utils/handleCMSNavigation";
import analytics from "@services/analytics";
import { OTHER_EVENTS } from "@constants/analyticsEventsCT";
import { parse } from "date-fns";
import entityStyle from "@utils/entityStyle";

const WebCMS = (props) => {
  const [token, setToken] = useState(null);
  const [error, setError] = useState(false);
  const webviewRef = useRef();

  const { marginTop: TOP_MARGIN } = entityStyle.entityContainer;

  const {
    image_dimension_height: widget_height = 0,
    image_link: widget_url = "",
    customEvent = "",
    customEventData = {},
    trackEvent = () => {},
    cms_item_id,
    title_ref = "",
    margin = false,
  } = props;

  const contentWidth = metrics.screenWidth;

  useEffect(() => {
    (async () => {
      try {
        const result = await getToken();
        if (result.token) setToken(result.token);
      } catch (err) {
        setToken(null);
      }
    })();
  }, [setToken]);

  const uriComponents = widget_url.split("&");
  const propsObj = {};
  uriComponents.map((el) => {
    const comp = el.split("=");
    propsObj[comp[0]] = comp[1];
  });

  let finalUrl =
    propsObj.useToken === "true"
      ? `${propsObj.url}?token=${token}`
      : propsObj.url;

  const handleWebPayload = (parsedData) => {
    const { type = "", payload = {} } = parsedData;
    if (type.trim() === "event") {
      const { eventName = "", eventData = {} } = payload;
      analytics.trackEvent(eventName, eventData); // capture clicks affecting inside web page
    } else if (type.trim() === "navigation") {
      trackEvent(OTHER_EVENTS.WEB_ENTITY_CLICKED, {
        cms_item_id,
        cms_title: title_ref,
      });
      const { link = "", link_type = "" } = payload;
      handleCMSNavigation(link, link_type); // capture clicks affecting the app
    }
  };

  const onMessage = (event) => {
    const parsedData = JSON.parse(event.nativeEvent.data);
    if (typeof parsedData === "object" && !Array.isArray(parsedData)) {
      handleWebPayload(parsedData);
    } else if (Array.isArray(parsedData)) {
      let newArray = [...parsedData];
      const [a, b] = parsedData;
      if (!a.type || !b.type) return;
      else if (a.type.trim() === b.type.trim()) return;
      else if (a.type.trim() === "navigation" && b.type.trim() === "event");
      newArray = [b, a];

      const [c, d] = newArray;
      const {
        payload: { eventName = "", eventData = {} },
      } = c;
      const {
        payload: { link, link_type },
      } = d;
      analytics.trackEvent(eventName, eventData);
      handleCMSNavigation(link, link_type);
    }
  };

  const handleWrapperClick = () => {
    const { link, link_type } = props;
    trackEvent(OTHER_EVENTS.WEB_ENTITY_CLICKED, {
      cms_item_id,
      cms_title: title_ref,
    });
    handleCMSNavigation(link, link_type);
  };

  const handleError = (syntheticEvent) => {
    const { nativeEvent } = syntheticEvent;
    setError(true);
  };

  const renderLoading = () => (
    <>
      <Svg
        width={metrics.screenWidth}
        height={+widget_height}
        viewBox={`0 0 ${metrics.screenWidth} ${widget_height}`}
      >
        <Rect
          x="0"
          y="0"
          rx="5"
          ry="5"
          fill="#ecebeb"
          width={metrics.screenWidth}
          height={+widget_height}
        />
      </Svg>
    </>
  );

  const enableClicks = propsObj.allowClick
    ? propsObj.allowClick === "true"
    : true;

  if (error) return <></>;
  return (
    <Pressable onPress={handleWrapperClick} disabled={enableClicks}>
      <View
        style={{
          width: contentWidth,
          alignItems: "center",
        }}
      >
        <View style={{ height: +widget_height, width: "100%" }}>
          <WebView
            scalesPageToFit={true}
            bounces={false}
            ref={webviewRef}
            onMessage={onMessage}
            javaScriptEnabled={enableClicks}
            source={{ uri: finalUrl }}
            onError={handleError}
            onHttpError={handleError}
            automaticallyAdjustContentInsets={true}
            startInLoadingState={true}
            renderLoading={renderLoading}
          />
        </View>
      </View>
    </Pressable>
  );
};

export default WebCMS;
